import { useEffect, useState } from 'react';
import { StringEnum } from '../../constants/enums/move-process-enum';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';

export const useOperatorAssignSingle = (context: any) => {
  const {
    enabled,
    taskId,
    processType,
    OperatorResponse,
    getOperatorState,
    resetOperatorResponse,
    resetCompleteProcessState,
    completeProcessState,
    removeForAbnormalityState,
    resetRemoveForAbnormalityState,
    GetOperatorService,
    CompleteProcessService,
    UpdateProcessService,
    startWebWorkerTimer,
    stopWebWorkerTimer,
    resetWebWorkerTimer,
    onSaveTeplarOrder,
    bulidCheckItemsPayload,
    buildMemoPayload,
    buildDimensionPayload,
    buildBOMCheckListPayload,
    mergedTabs,
    trayHistory,
    setTrayHistory,
    trayIndex,
    setTrayIndex,
    selectedTrayId,
    setSelectedTrayId,
    setActiveIndex,
    setSubmittedCheckItems,
    setMemo,
    setDimensionChecks,
    setCanvasDrawings,
    setBomDataListState,
    startDateTime,
    setStartDateTime,
    startTimer,
    setStartTimer,
    timer,
    setTimer,
    webWorkerTime,
    setWebWorkerTime,
    isTimerRunning,
    setIsTimerRunning,
    isProcessStarted,
    setIsProcessStarted,
    operatorCount,
    setOperatorCount,
    scanBuffer,
    setScanBuffer,
    lastKeyTime,
    setLastKeyTime,
    traySelectRef,
    removeTaskToggleHandler,
    setRemoveDuration,
    areAllTabsChecked,
    isBOMValidated,
    bomDataList,
    resetGetOperatorState,
    buildTeplarListPayload,
    teplarList,
    setTeplarList,
    isRemoveForAbnormalityClicked,
    setIsRemoveForAbnormalityClicked,
    CheckProcessStatus,
    showStart,
    setShowStart,
    showConfirmModal,
  } = context;

  const [abnormalTrays, setAbnormalTrays] = useState<string[]>([]);
  const [pausedTrayIds, setPausedTrayIds] = useState<string[]>([]);

  const saveTeplarOrderIfNeeded = async () => {
    if (Number(processType) !== 2 || !onSaveTeplarOrder) {
      return;
    }
    await onSaveTeplarOrder();
  };

  useEffect(() => {
    if (!enabled) return;
    if (completeProcessState.success) {
      resetCompleteProcessState();
    }
  }, [completeProcessState.success, enabled]);

  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (e) => {
      const currentTime = Date.now();
      const timeDiff = currentTime - lastKeyTime;

      if (!e.key) return;

      if (
        e.key === 'Shift' ||
        e.key === 'Control' ||
        e.key === 'Alt' ||
        e.key === 'CapsLock' ||
        (e.key.length > 1 && e.key !== 'Enter')
      ) {
        return;
      }

      if (e.key === 'Enter') {
        if (timeDiff > 100) {
          e.preventDefault();
          return;
        }
        // if (isTimerRunning) {
        //   e.preventDefault();
        //   toast.error(formatMessage('please_complete_the_tray_to_scan'));
        //   return;
        // }
        e.preventDefault();
        const cleanedScan = scanBuffer.trim();
        if (cleanedScan === selectedTrayId) {
          return;
        }
        if (trayHistory.includes(cleanedScan)) {
          getSelectedTrayDetails(cleanedScan);
          traySelectRef.current?.focus();
          return;
        } else if (isTimerRunning) {
          handlePauseTimer();
          setTrayHistory((prev) => [...prev, cleanedScan]);
          getActiveTrayListServiceHandler(cleanedScan);
          setScanBuffer('');
          traySelectRef.current?.focus();
          return;
        }
        setTrayHistory((prev) => [...prev, cleanedScan]);
        getActiveTrayListServiceHandler(cleanedScan);
        setScanBuffer('');
        traySelectRef.current?.focus();
        return;
      }

      if (timeDiff > 100) {
        setScanBuffer(e.key);
      } else {
        setScanBuffer((prev) => prev + e.key);
      }

      setLastKeyTime(currentTime);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [enabled, scanBuffer, lastKeyTime, trayHistory, isTimerRunning]);

  useEffect(() => {
    if (!enabled) return;
    if (removeForAbnormalityState.success) {
      removeTaskToggleHandler();
      resetRemoveForAbnormalityState();
      setIsTimerRunning(false);
      setOperatorCount(1);
      setIsProcessStarted(false);
      setTimer(0);
      resetWebWorkerTimer();
      syncSelectionAfterTrayRemoval();
    }
  }, [enabled, removeForAbnormalityState.success]);

  useEffect(() => {
    if (!enabled) return;
    if (removeForAbnormalityState.error) {
      resetRemoveForAbnormalityState();
    }
  }, [enabled, removeForAbnormalityState.error]);

  useEffect(() => {
    if (!enabled) return;
    const hasCurrentTrayResponse =
      OperatorResponse?.TrayId &&
      selectedTrayId &&
      String(OperatorResponse.TrayId) === String(selectedTrayId);

    if (!hasCurrentTrayResponse) {
      if (trayHistory.length === 0) {
        setTimer(0);
      }
      return;
    }

    if (OperatorResponse.TimeDuration) {
      const initialDuration = Number(OperatorResponse.TimeDuration) || 0;
      setTimer(initialDuration);
      setWebWorkerTime(initialDuration);
    }

    if (OperatorResponse.CurrentState === StringEnum.Lock) {
      setAbnormalTrays((prev) =>
        prev.includes(OperatorResponse.TrayId)
          ? prev
          : [...prev, OperatorResponse.TrayId]
      );
    }

    if (OperatorResponse.FileList && OperatorResponse.FileList.length > 0) {
      const isTrue = (val: any) =>
        val === true || String(val).toLowerCase() === 'true';

      let bestIndex = 0;
      let bestPriority = 2;

      OperatorResponse.FileList.forEach((file, index) => {
        let priority = 2;
        if (isTrue(file.IsDefault) || isTrue(file.isDefault)) {
          priority = 0;
        } else if (isTrue(file.IsDimension) || isTrue(file.isDimension)) {
          priority = 1;
        }

        if (priority < bestPriority) {
          bestPriority = priority;
          bestIndex = index;
        }
      });

      setActiveIndex(bestIndex);
    }
  }, [enabled, OperatorResponse, selectedTrayId, trayHistory.length]);

  useEffect(() => {
    if (!enabled) return;
    if (!OperatorResponse?.FileList?.length) return;

    const isTrue = (val: any) =>
      val === true || String(val).toLowerCase() === 'true';
    const defaultIndex = mergedTabs.findIndex(
      (t) => isTrue(t.data?.IsDefault) || isTrue(t.data?.isDefault)
    );
    if (defaultIndex !== -1) {
      setActiveIndex(defaultIndex);
    } else {
      const dimensionIndex = mergedTabs.findIndex(
        (t) => isTrue(t.data?.IsDimension) || isTrue(t.data?.isDimension)
      );
      if (dimensionIndex !== -1) {
        setActiveIndex(dimensionIndex);
      } else {
        setActiveIndex(0);
      }
    }

    const hydratedCheckItems: any = {};
    const hydratedMemo: Record<number, string> = {};

    OperatorResponse.FileList?.forEach((fileItem: any, fileIndex: number) => {
      const checkItemsGroups = fileItem?.CheckItems ?? [];
      const memoKey = fileItem?.TabIndex ?? fileIndex;
      const existingMemo =
        Array.isArray(fileItem?.MemoMessage) && fileItem.MemoMessage.length > 0
          ? fileItem.MemoMessage[0]
          : null;

      hydratedMemo[memoKey] = existingMemo?.Memo ?? '';

      if (checkItemsGroups.length === 0) return;

      hydratedCheckItems[fileIndex] = {};

      checkItemsGroups.forEach((group: any) => {
        const messages = group?.CheckItemMessage ?? [];
        messages.forEach((item: any) => {
          if (item.Id === undefined || item.Id === null) return;
          hydratedCheckItems[fileIndex][item.Id] = {
            isChecked: false,
            InputMessage: item.InputMessage || '',
          };
        });
      });
    });

    setSubmittedCheckItems(hydratedCheckItems);
    setMemo(hydratedMemo);
    setCanvasDrawings({});
  }, [enabled, OperatorResponse, mergedTabs]);

  useEffect(() => {
    if (!enabled) return;
    if (mergedTabs.length === 0) return;

    const initialState: any = {};

    mergedTabs.forEach((tab, tabIndex) => {
      const checkItems = tab?.data?.CheckItems ?? [];

      checkItems.forEach((item: any) => {
        item.CheckItemMessage?.forEach((msg: any) => {
          if (!initialState[tabIndex]) initialState[tabIndex] = {};
          initialState[tabIndex][msg.Id] = {
            isChecked: msg.IsChecked,
            InputMessage: msg.InputMessage || '',
          };
        });
      });
    });

    setSubmittedCheckItems((prev) => {
      const prevStr = JSON.stringify(prev);
      const nextStr = JSON.stringify(initialState);
      return prevStr === nextStr ? prev : initialState;
    });
  }, [enabled, mergedTabs]);

  useEffect(() => {
    if (!enabled) return;
    if (!OperatorResponse?.FileList?.length) return;

    const hydratedDimensions: Record<string, boolean> = {};

    OperatorResponse.FileList.forEach((file: any) => {
      const dims = file.DimensionsData ?? [];

      dims.forEach((dim: any) => {
        if (dim.DimensionType !== 1) return;

        const values = dim.DimensionValues ?? [];

        values.forEach((val: string, rowIndex: number) => {
          const [, checkedFlag] = String(val).split('$');
          const key = `${rowIndex}-${dim.Id}`;
          hydratedDimensions[key] = checkedFlag === 'true';
        });
      });
    });

    setDimensionChecks(hydratedDimensions);
  }, [enabled, OperatorResponse]);

  useEffect(() => {
    if (!enabled) return;
    if (bomDataList?.length > 0) {
      setBomDataListState(bomDataList);
    } else {
      setBomDataListState([]);
    }
  }, [enabled, bomDataList]);

  useEffect(() => {
    if (!enabled) return;
    if (trayHistory.length > 0 && getOperatorState.success) {
      // const initialDuration = Number(OperatorResponse?.TimeDuration) || 0;
      handleStartClick();
    }
    resetGetOperatorState();
  }, [enabled, getOperatorState.success]);

  const removeTrayDataOnProcessCompletion = (trayId: string) => {
    const trayData = JSON.parse(localStorage.getItem('trayData') || '{}');
    if (trayData[trayId]) {
      delete trayData[trayId];
      localStorage.setItem('trayData', JSON.stringify(trayData));
    }
    if (trayData.length === 1 && trayData[trayId]) {
      localStorage.removeItem('trayData');
    }
  };

  const getActiveTrayListServiceHandler = (trayId?: string) => {
    const currentTray = trayId || trayHistory[trayIndex];
    if (!currentTray) return;

    // Don't clear existing data immediately
    setSelectedTrayId(currentTray);
    // setActiveIndex(-1);
    // resetOperatorResponse();
    // setSubmittedCheckItems({});
    // setMemo({});
    // setDimensionChecks({});
    // setCanvasDrawings({});

    if (trayId) {
      setTrayIndex(0);
    } else if (trayHistory.length > 0) {
      setTrayIndex((prevIndex) => (prevIndex + 1) % trayHistory.length);
    }

    GetOperatorService(
      Number(getTenantIdFromLocalStorage()),
      currentTray,
      taskId,
      Number(processType)
    );
  };

  const getSelectedTrayDetails = (trayId: string) => {
    setSelectedTrayId(trayId);
    // setSelectedTray(trayId);
    setActiveIndex(-1);
    resetOperatorResponse();
    setSubmittedCheckItems({});
    setMemo({});
    setDimensionChecks({});
    setCanvasDrawings({});
    GetOperatorService(
      Number(getTenantIdFromLocalStorage()),
      trayId,
      taskId,
      Number(processType)
    );
    setWebWorkerTime(OperatorResponse.TimeDuration || 0);
    setOperatorCount(1);
    setIsTimerRunning(false);
  };

  const syncSelectionAfterTrayRemoval = () => {
    const updatedTrayHistory = trayHistory.filter(
      (trayId: string) => trayId !== selectedTrayId
    );

    setTrayHistory(updatedTrayHistory);
    setAbnormalTrays((prev) =>
      prev.filter((trayId: string) => trayId !== selectedTrayId)
    );
    setPausedTrayIds((prev) =>
      prev.filter((trayId: string) => trayId !== selectedTrayId)
    );

    if (updatedTrayHistory.length === 0) {
      setSelectedTrayId(null);
      // setSelectedTray('');
      setActiveIndex(-1);
      setSubmittedCheckItems({});
      setMemo({});
      setDimensionChecks({});
      setCanvasDrawings({});
      setBomDataListState([]);
      resetOperatorResponse();
      return;
    }

    setSelectedTrayId(updatedTrayHistory[updatedTrayHistory.length - 1]);
    getSelectedTrayDetails(updatedTrayHistory[updatedTrayHistory.length - 1]);
  };

  const handleRemoveTray = () => {
    syncSelectionAfterTrayRemoval();
  };

  const completeSuccess = () => {
    const trayIdValue = selectedTrayId;

setIsTimerRunning(false);
    setTimer(0);
    resetWebWorkerTimer();
    setOperatorCount(1);
    setIsProcessStarted(false);
    setPausedTrayIds((prev) =>
      prev.filter((trayId: string) => trayId !== trayIdValue)
    );
    handleRemoveTray();
    setMemo([]);
    setDimensionChecks([]);
    setSubmittedCheckItems({});
    setCanvasDrawings({});
    removeTrayDataOnProcessCompletion(trayIdValue);
    resetWebWorkerTimer();
  }

  const handleCompleteProcess = () => {
    saveTeplarOrderIfNeeded();
    const trayIdValue = selectedTrayId;

    const submitObj = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      TrayId: [trayIdValue],
      Count: 1,
      ProcessId: taskId,
      StartTime: startDateTime,
      EndTime: new Date().toISOString(),
      Duration: webWorkerTime - startTimer,
      NoOfOperators: operatorCount,
      CurrentState: abnormalTrays.includes(selectedTrayId)
        ? StringEnum.Lock
        : '',
      IsPaused: false,
      IsBatch: false,
      CheckItemList: bulidCheckItemsPayload(),
      MemoMessage: buildMemoPayload(),
      Dimensions: buildDimensionPayload(),
      BOMCheckList: buildBOMCheckListPayload(),
      TeplarList: buildTeplarListPayload(),
    };
    CompleteProcessService(submitObj);
    completeSuccess();
  };

  const handleStartClick = async () => {
    const updateObj = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      TrayId: [selectedTrayId],
      ProcessId: taskId,
      SetActive: true,
    };
    await CheckProcessStatus(updateObj);

    // const updateObj = {
    //   TenantId: Number(getTenantIdFromLocalStorage()),
    //   TrayId: trayHistory?.map((tray) => tray.trim()),
    //   ProcessId: taskId,
    //   SetActive: true,
    // };
    // await UpdateProcessService(updateObj);
  };

  const handleStartTimer = async (initialDuration?: number) => {
    const updateObj = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      TrayId: [selectedTrayId],
      ProcessId: taskId,
      SetActive: true,
    };
    UpdateProcessService(updateObj);
    const resolvedInitialDuration =
      typeof initialDuration === 'number' ? initialDuration : webWorkerTime;

    if (selectedTrayId) {
      setPausedTrayIds((prev) =>
        prev.filter((trayId: string) => trayId !== selectedTrayId)
      );
    }
    setTimer(resolvedInitialDuration);
    setWebWorkerTime(resolvedInitialDuration);
    startWebWorkerTimer(resolvedInitialDuration);
    setStartDateTime(new Date().toISOString());
    setIsTimerRunning(true);
    setIsProcessStarted(true);
    setStartTimer(resolvedInitialDuration);
  };

  const PausedSuccess = () => {
    setIsTimerRunning(false);
    if (selectedTrayId) {
      setPausedTrayIds((prev) =>
        prev.includes(selectedTrayId) ? prev : [...prev, selectedTrayId]
      );
    }
  }

  const handlePauseTimer = () => {
    stopWebWorkerTimer();
    saveTeplarOrderIfNeeded();
    const submitObj = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      TrayId: [selectedTrayId],
      Count: 1,
      ProcessId: taskId,
      StartTime: startDateTime,
      EndTime: new Date().toISOString(),
      Duration: webWorkerTime - startTimer,
      NoOfOperators: operatorCount,
      CurrentState: abnormalTrays.includes(selectedTrayId)
        ? StringEnum.Lock
        : '',
      IsPaused: isTimerRunning ? true : false,
      IsBatch: false,
      CheckItemList: bulidCheckItemsPayload(),
      MemoMessage: buildMemoPayload(),
      Dimensions: buildDimensionPayload(),
      BOMCheckList: buildBOMCheckListPayload(),
      TeplarList: buildTeplarListPayload(),
    };

    CompleteProcessService(submitObj);
    PausedSuccess();
  };

  const removeTrayServiceHandler = () => {
    const obj = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      TrayId: [selectedTrayId],
      ProcessId: taskId,
      SetActive: false,
    };
    // UpdateProcessService(obj);
    handleRemoveTray();
    setTimer(0);
    resetWebWorkerTimer();
  };

  const handleRemoveForAbnormality = () => {
    setIsRemoveForAbnormalityClicked(isTimerRunning);
    if (isTimerRunning) {
      stopWebWorkerTimer();
      setIsTimerRunning(false);
    }
    setRemoveDuration(isTimerRunning ? webWorkerTime - startTimer : 0);
    saveTeplarOrderIfNeeded();
    removeTaskToggleHandler();
  };

  const handleTraySelectChange = (nextTrayId: string) => {
    if (isTimerRunning) {
      setIsTimerRunning(false);
      handlePauseTimer();
      // CompleteProcessService(submitObj);
      setIsProcessStarted(false);
    }
    getSelectedTrayDetails(nextTrayId);
  };

  const addTray = (trayId: string) => {
    if (isTimerRunning) {
      handlePauseTimer();
      if (trayHistory.includes(trayId)) {
        getSelectedTrayDetails(trayId);
        return;
      } else {
        setTrayHistory((prev) => [...prev, trayId]);
        getSelectedTrayDetails(trayId);
      }
    } else {
      setTrayHistory((prev) => [...prev, trayId]);
      getSelectedTrayDetails(trayId);
    }
  };

  const shouldShowTrayWarning = (tray: string) => {
    if (!isTimerRunning) return false;
    return tray === selectedTrayId && !(areAllTabsChecked && isBOMValidated);
  };

  const shouldShowCheckMark = (tray: string) => {
    if (!isTimerRunning) return false;
    return tray === selectedTrayId && areAllTabsChecked && isBOMValidated;
  };

  const canShowStartButton =
    (!isTimerRunning &&
      trayHistory.length > 0 &&
      selectedTrayId &&
      pausedTrayIds.includes(selectedTrayId)) ||
    !showConfirmModal;

  const buttons = [
    ...(isTimerRunning
      ? [
          {
            labelKey: 'pause',
            className: 'btn-secondary',
            onClick: handlePauseTimer,
            isDisabled: !isTimerRunning,
          },
          {
            labelKey: 'complete',
            className: 'btn-primary',
            onClick: handleCompleteProcess,
            isDisabled:
              trayHistory.length === 0 ||
              !isProcessStarted ||
              !(areAllTabsChecked && isBOMValidated),
          },
        ]
      : canShowStartButton
        ? [
            {
              labelKey: 'start',
              className: 'btn-success',
              onClick: handleStartClick,
              isDisabled: trayHistory.length === 0 || isTimerRunning,
            },
          ]
        : []),
    {
      labelKey: 'remove',
      className: 'btn-danger',
      onClick: removeTrayServiceHandler,
      isDisabled: trayHistory.length === 0 || isTimerRunning,
    },
    {
      labelKey: 'remove_for_abnormality',
      className: 'btn-outline-danger',
      onClick: handleRemoveForAbnormality,
      isDisabled: trayHistory.length === 0,
    },
  ];

  return {
    buttons,
    shouldShowTrayWarning,
    handleTraySelectChange,
    addTray,
    handlePauseTimer,
    shouldShowCheckMark,
    handleStartTimer,
    handleRemoveTray,
    handleStartClick,
    completeSuccess,
    PausedSuccess
  };
};
